import React, { Component } from 'react';
import '../../styles/css/loading.css';

export default class Loading extends Component {
  render() {
    return (
      <div
        className="d-flex w-100 h-100 justify-content-center align-items-center"
        // style={{ margin: 'auto', textAlign: 'center' }}
      >
        <div className="lds-default">
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    );
  }
}
